import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonContent,
  IonRefresher,
  IonRefresherContent,
} from '@ionic/react';
import { Switch } from 'react-router';
import { connect } from 'react-redux';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useLocation, useHistory } from 'react-router-dom';
import UserPLStatement from '../pages/UserPLStatement/UserPLStatement';
import AccountStatement from '../pages/AccountStatement/AccountStatement';
import AccountStatementEventLevelView from '../pages/AccountStatement/AccountStatementEventLevel';
import Home from '../pages/Home/Home';
import CasinoNew from '../pages/Casino/CasinoNew/CasinoNew';
import SlotGames from '../pages/Casino/CasinoNew/SlotGames';
import VirtualGames from '../pages/Casino/CasinoNew/VirtualSports';
import CasinoIframeNew from '../pages/Casino/CasinoIframeNew/CasinoIframeNew';
import Header from '../components/Header/Header';
import MyBets from '../pages/MyBets/MyBets';
import UserRoute from '../hoc/UserRoute';
import MyWallet from '../pages/MyWallet/MyWallet';
import GameReport from '../pages/GameReport/GameReport';
import { RootState } from '../models/RootState';
import RulesAndRegulations from '../pages/RulesAndRegulations/RulesAndRegulations';
import ResponsibleGambling from '../pages/ResponsibleGambling/ResponsibleGambling';
import TermsConditions from '../pages/TermsConditions/TermsConditions';
import PunterSettings from '../pages/PunterSettings/PunterSettings';
import MyProfile from '../components/MyProfile/MyProfile';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import MobileFooter from '../components/Header/MobileFooter/MobileFooter';
import ButtonVariables from '../components/ButtonVariables/ButtonVariables';
import {
  enableCommission,
  fetchBalance,
  getAccountIdFromToken,
  getHouseIdFromToken,
  getParentIdFromToken,
  setAllowedConfig,
} from '../store';
import './UserRouter.scss';
import ExchangeSportsBook from '../pages/ExchSportsBook/ExchangeSportsBook';
import { useInterval } from '../hooks/useInterval';
import API from '../api';
import '../assets/global_styles/marquee.scss';
import DashboardView from '../pages/DashboardView/DashboardView';
import { ALLOW_CASINO } from '../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../constants/ConfigPermission';
import UserCommissionReport from '../pages/UserCommission/UserCommissionReport';
import UserCommissionBySportView from '../pages/UserCommission/UserCommissionBySportView';
import SubHeader from '../views/SubHeader/SubHeader';
import TVGamesView from '../pages/TvGames/TVGamesView';
import GapCasinoIframe from '../pages/Casino/CasinoIframeNew/GapCasinoIframe';
import PrivacyInfo from '../components/Footer/PrivacyInfo';
import ConditionInfo from '../components/Footer/ConditionInfo';
import RulesInfo from '../components/Footer/RulesInfo';
import SportsProviderIframe from '../pages/SportsProvider/SportsProviderIframe';
import ChangePasswordPage from '../components/ChangePassword/ChangePasswordPage';
import NotificationPage from '../components/NotificationPage/NotificationPage';
import MobOneClick from '../components/ExchBetslip/MobOneClick';
import MicNoneIcon from '@material-ui/icons/MicNone';
import API_V2 from '../api-services/svls-api';
import ThemeChangesPage from '../components/Dashboard/ThemeChangesPage';
import ThemeChanges from '../components/Header/ThemeChanges';
import { BRAND_NAME } from '../constants/Branding';
import { isIOS } from 'react-device-detect';
import MlobbyIframeNew from '../pages/Casino/MlobbyIframeNew/MlobbyIframeNew';
import {
  checkPNStompClientSubscriptions,
  connectToPushNotification,
  disConnectToPushNotificationWS,
  subscribeWsForNotifications,
  subscribeWsForNotificationsPerAdmin,
} from '../webSocket/webSocket';

type StateProps = {
  role: string;
  allowedConfig: number;
  commissionEnabled: boolean;
  status: number;
  loggedIn: boolean;
  fetchBalance: () => void;
  setAllowedConfig: (allowedConfig: number) => void;
  setEnableCommission: (commission: boolean) => void;
  balanceChanged: number;
  houseId: string;
  parentId: string;
  accountId: string;
  notificationUpdated: number;
  pushNotifWSConnection: boolean;
};

const UserRouter: React.FC<StateProps> = (props) => {
  const {
    role,
    allowedConfig,
    status,
    loggedIn,
    fetchBalance,
    setAllowedConfig,
    setEnableCommission,
    balanceChanged,
    houseId,
    parentId,
    accountId,
    notificationUpdated,
    pushNotifWSConnection
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const history = useHistory();
  const location = useLocation();
  const pathName = location.pathname;
  const [notifications, setNotifications] = useState<any[]>([]);
  const [showNotificationModal, setShowNotificationModal] =
    useState<boolean>(false);

  const redirectUser = () => {
    let redirectionURL = null;
    if ((allowedConfig & 31) === 0) {
      if (
        (allowedConfig & CONFIG_PERMISSIONS.sports) !== 0 &&
        pathName.includes('casino')
      ) {
        redirectionURL = '/home';
      } else if (
        (allowedConfig & CONFIG_PERMISSIONS.casino) !== 0 &&
        pathName.includes('exchange_sports')
      )
        redirectionURL = '/home';
    } else if (
      (allowedConfig & CONFIG_PERMISSIONS.casino) === 0 &&
      pathName.includes('casino')
    ) {
      redirectionURL = '/home';
    } else if (
      (allowedConfig & CONFIG_PERMISSIONS.sports) === 0 &&
      pathName.includes('exchange_sports')
    ) {
      redirectionURL = '/home';
    } else if (
      (allowedConfig & CONFIG_PERMISSIONS.indian_casino) === 0 &&
      pathName.includes('indian_casino')
    ) {
      redirectionURL = '/home';
    } else if (
      (allowedConfig & CONFIG_PERMISSIONS.live_casino) === 0 &&
      pathName.includes('/dc/')
    ) {
      redirectionURL = '/home';
    }

    if (redirectionURL) history.push(redirectionURL);
  };

  useEffect(() => {
    redirectUser();
  }, [pathName, allowedConfig, loggedIn]);

  const getAllowedConfig = async () => {
    let response;
    if (!loggedIn) {
      response = await API_V2.get('/catalog/v2/settings/catalog-config');
    } else {
      response = await API_V2.get('/catalog/v2/settings/catalog-config', {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
      });
    }
    if (response.status === 200) {
      setAllowedConfig(response?.data?.allowedConfig);
      setEnableCommission(response?.data?.commissionEnabled);
    }
  };

  useEffect(() => {
    if (loggedIn) {
      fetchBalance();
    }
  }, [loggedIn, balanceChanged]);

  useEffect(() => {
    if (loggedIn) {
      let refreshInterval = setInterval(() => {
        checkPNStompClientSubscriptions();
      }, 10000);
      return () => {
        clearInterval(refreshInterval);
      };
    }
  }, []);

  // Websocket handler
  useEffect(() => {
    if (loggedIn) {
      if (pushNotifWSConnection) {
        disConnectToPushNotificationWS();
      }
      connectToPushNotification();
    }

    return () => {
      if (pushNotifWSConnection) {
        disConnectToPushNotificationWS();
      }
    };
  }, [loggedIn]);

  useEffect(() => {
    if (
      loggedIn &&
      !window.location.pathname.includes('==') &&
      !window.location.pathname.includes('multi-markets')
    ) {
      subscribeWsForNotifications(false, houseId);
      subscribeWsForNotificationsPerAdmin(false, houseId, parentId, accountId);
    }
  }, [pushNotifWSConnection, loggedIn]);

  const getNotificationMessages = (notificationsList: any) => {
    let notfMsg = ' ';
    for (let i = 0; i < notificationsList.length; i++) {
      if (notificationsList[i].active) {
        notfMsg += ' ' + notificationsList[i].message;
        notfMsg += notificationsList[i + 1] ? '  ' + '  '.repeat(8) : '';
      }
    }

    return notfMsg;
  };

  useEffect(() => {
    if (loggedIn) {
      fetchNotifications();
    }
  }, [loggedIn, notificationUpdated]);

  useEffect(() => {
    getAllowedConfig();
  }, [loggedIn]);

  const fetchNotifications = async () => {
    const response = await API_V2.get('/catalog/v2/notifications/', {
      headers: {
        Authorization: sessionStorage.getItem('jwt_token'),
      },
      params: {
        type: 'ACTIVE',
      },
    });
    // setNotifications(response.data.filter((n) => n.active));
    setNotifications(response.data);
  };

  const ShowNotificationWindow = () => {
    window.open(
      '/allAnnouncement',
      '',
      'toolbar=no,status=no,menubar=no,location=center,scrollbars=no,resizable=no,height=500,width=657'
    );
  };

  return (
    <>
      {status !== -1 && status === 4 ? (
        <Redirect to="/reset-password" />
      ) : status !== -1 && status === 2 ? (
        <Redirect to="/terms-and-conditions" />
      ) : role && role !== 'User' ? (
        <Redirect to="/access-redirect" />
      ) : !ALLOW_CASINO &&
        (window.location.pathname.includes('/casino') ||
          window.location.pathname.includes('/dc/gamev1.1/')) ? (
        <Redirect to="/access-redirect" />
      ) : (
        <IonApp>
          {!window.location.pathname.includes('/dc/gamev1.1/') &&
          notifications?.length > 0 ? (
            <div
              className="marquee notifications"
              onClick={() => ShowNotificationWindow()}
            >
              <div className="info">
                <MicNoneIcon fontSize="small" /> News
              </div>
              <span>{getNotificationMessages(notifications)}</span>
              <div className="view-all">{/* <NotificationsIcon /> */}</div>
            </div>
          ) : null}
          {!(window.location.pathname.includes('/dc/gamev1.1/') && isMobile) ? (
            <>
              <Header></Header>
              <SubHeader></SubHeader>
            </>
          ) : null}

          <IonContent className="bg">
            <IonRefresher
              slot="fixed"
              onIonRefresh={() => window.location.reload()}
            >
              <IonRefresherContent refreshingSpinner="circular"></IonRefresherContent>
            </IonRefresher>

            <div className="router-ctn">
              {loggedIn && !isMobile ? <ThemeChanges /> : null}

              <Switch>
                <Route
                  path="/mo/theme"
                  component={ThemeChangesPage}
                  exact={true}
                />
                <Route path="/home" component={Home} exact={true} />
                <Route path="/casino" component={CasinoNew} exact={true} />
                <Route
                  path="/mo/oneclick"
                  component={MobOneClick}
                  exact={true}
                />

                <Route
                  path="/casino/:provider"
                  component={CasinoNew}
                  exact={true}
                />
                <Route path="/slot_games" component={SlotGames} exact={true} />

                <Route
                  path="/premium_sports"
                  component={SportsProviderIframe}
                  exact={true}
                />
                <Route
                  path="/virtual_games"
                  component={VirtualGames}
                  exact={true}
                />
                <Route path="/tv_games" component={TVGamesView} exact={true} />
                <Route path="/dc" component={CasinoNew} exact={true} />
                <Route
                  path="/gap_casino"
                  component={GapCasinoIframe}
                  exact={true}
                />
                <Route
                  path="/change-password"
                  component={ChangePasswordPage}
                  exact={true}
                />
                <Route
                  path="/my-notification"
                  component={NotificationPage}
                  exact={true}
                />

                <Route
                  path="/resetPassword"
                  component={ResetPassword}
                  exact={true}
                />
                <Route
                  path="/dc/gamev1.1/:gamePath"
                  component={CasinoIframeNew}
                  exact={true}
                />
                <Route
                  path="/gap_casino/game/:gamePath"
                  component={GapCasinoIframe}
                  exact={true}
                />
                <Route
                  path="/exchange_sports"
                  render={() => <ExchangeSportsBook />}
                ></Route>
                <Route
                  path="/dashboard"
                  render={() => <DashboardView />}
                ></Route>
                <UserRoute
                  path="/account_statement"
                  component={AccountStatement}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/market_account_statement"
                  component={AccountStatementEventLevelView}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/my_bets"
                  component={MyBets}
                  exact={true}
                ></UserRoute>
                {/* <UserRoute
                  path="/my_wallet"
                  component={MyWallet}
                  exact={true}
                ></UserRoute> */}
                <UserRoute
                  path="/pl_statement"
                  component={UserPLStatement}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/game_report"
                  component={GameReport}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/commission_report"
                  component={UserCommissionReport}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/commission_report/:eventId"
                  component={UserCommissionBySportView}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/settings"
                  component={PunterSettings}
                  exact={true}
                ></UserRoute>
                <UserRoute
                  path="/profile"
                  component={MyProfile}
                  exact={true}
                ></UserRoute>
                <Route exact path="/" render={() => <Redirect to="/home" />} />
                <Route path="/rules" render={() => <RulesAndRegulations />} />
                <Route
                  path="/responsible-gambling"
                  render={() => <ResponsibleGambling />}
                />
                <Route
                  path="/terms-conditions"
                  render={() => <TermsConditions />}
                />
                <Route
                  path="/set-button-variables"
                  render={() => <ButtonVariables />}
                />
                <Route path="/home/rules" render={() => <RulesInfo />} />
                <Route path="/home/policy" render={() => <PrivacyInfo />} />
                <Route
                  path="/home/term-conditions"
                  render={() => <ConditionInfo />}
                />
              </Switch>
            </div>
          </IonContent>
          <div className="mob-header">
            <MobileFooter />
          </div>
          {isMobile || isIOS ? (
            <div className="mob-view">
              <MlobbyIframeNew />
            </div>
          ) : null}
        </IonApp>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  if (!state.auth.loggedIn) {
    return {
      role: null,
      status: -1,
      allowedConfig: state.common.allowedConfig,
    };
  }
  let claim = state.auth?.jwtToken?.split('.')[1] || '';
  const role = JSON.parse(window.atob(claim)).role;
  const status = JSON.parse(window.atob(claim)).sts;
  return {
    loggedIn: state.auth.loggedIn,
    role: role,
    status,
    allowedConfig: state.common.allowedConfig,
    commissionEnabled: state.common.commissionEnabled,
    balanceChanged: state.common.balanceChanged,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: getAccountIdFromToken(),
    notificationUpdated: state.common.notificationUpdated,
    pushNotifWSConnection: state.exchangeSports.pushNotifWSConnection,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchBalance: () => dispatch(fetchBalance()),
    setAllowedConfig: (allowedConfig: number) =>
      dispatch(setAllowedConfig(allowedConfig)),
    setEnableCommission: (commission: boolean) =>
      dispatch(enableCommission(commission)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRouter);
